export enum ConsentTypes {
  Default = 'DEFAULT',
  Custom = 'TERMS_CONDITIONS'
}
